import React from 'react';

import {
  useEventState,
  useEventActions,
} from './EventContext';
import Button from '../../Shared/UI/Button/components/Button';

import { createEvent } from './restApi';

import styles from './EventPublishingWorkflowControls.module.scss';

const EventPublishingWorkflowControls = ({ documentManagerWrapperState }) => {
  const state = useEventState();
  const { onResponse, onError } = useEventActions();

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  return (
    <div id={styles.eventPublishingWorkflowControlsContainer}>
      <div />
      {state.inEditMode && (
        <Button
          text="Save"
          variant="primary"
          onClick={() => {

            createEvent({
              onResponse,
              onError,
              body: {
                authenticityToken,
                event: {
                  ...state.event,
                  description: documentManagerWrapperState.documentManager.getCurrentDocument().asJSON(),
                },
              },
            });
          }}
        />
      )}
      {/* {!state.inEditMode && (
        <Button
          text="Edit"
          variant="primary"
          onClick={() => {}}
        />
      )} */}
    </div>
  );
};

export default EventPublishingWorkflowControls;
